import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

import { Fancybox } from "@fancyapps/ui"

import Swup from 'swup'
import SwupJsPlugin from '@swup/js-plugin'
import SwupHeadPlugin from '@swup/head-plugin'
import SwupBodyClassPlugin from '@swup/body-class-plugin'
import SwupScriptsPlugin from '@swup/scripts-plugin'
import SwupPreloadPlugin from '@swup/preload-plugin'

import pageTransition from "./swup/page-transition"

// ----- import components

import Header from "../blocks/modules/header/header"
import ScrollAnimate from "./global/scroll-animate"
import Textarea from "../blocks/components/textarea/textarea"
import MSlider from "../blocks/components/m-slider/m-slider"
import VideoOnVisible from "./global/video-on-visible"
import Rating from "../blocks/components/rating/rating"

// ----- import functions

import { scrollToId } from "./global/scrollToId"

// ----- env

// import { BASE_URL } from '../../env-config'

// ----- components instances

// let loader = null
let scrollAnimate = null
let header = null

let textarea = []
let mslider = []
let video = []
let rating = []

// ----- flags

let isMobile = false
let isFirstLoad = true

// ----- page elements

function isWebp() {
  // Checking support webp
  function testWebP(callback) {
    let webP = new Image();
    webP.onload = webP.onerror = function () {
      callback(webP.height == 2);
    };
    webP.src =
      "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
  }

  testWebP(function (support) {
    let className = support == true ? "webp" : "no-webp";
    document.documentElement.classList.add(className);
  });
}

isWebp()

function checkMobile () {
  isMobile = /iPad|iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/.test(navigator.userAgent)

  if(!isMobile && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel|iPad/.test(navigator.platform)) {
    isMobile = true
  }

  if (!isMobile && window.innerWidth < 1025) {
    isMobile = true
  }

  if (isMobile) {
    document.body.classList.add('mobile')
  }
}

const swup = new Swup({
  plugins: [
    new SwupHeadPlugin(),
    new SwupJsPlugin(pageTransition),
    new SwupBodyClassPlugin(),
    new SwupScriptsPlugin({
      optin: true
    }),
    new SwupPreloadPlugin({
      preloadInitialPage: false
    })
  ],
  cache: true,
  animateHistoryBrowsing: true,
  containers: ['#swup', '#header', '#footer', '.js-modal']
});

swup.on('animationOutDone', () => {
  window.scrollTo(0, 0)
  destroy()
})

swup.on('contentReplaced', () => {
  isWebp()
  checkMobile()
  document.body.classList.add('block-scroll')
  init()
});

swup.on('animationInDone', () => {
  document.body.classList.remove('block-scroll')
})

// ----- events

window.addEventListener('load', async () => {
  onLoad()
})

document.addEventListener('DOMContentLoaded', () => {
  onReady()
})

// ----- on window load

const onLoad = () => {

  scrollAnimate.init()
  isFirstLoad = false

}

// ----- on document ready. Call once on first time load

function onReady () {
  checkMobile()
  scrollToId()

  // ----- init components

  $(document).on('click', '[data-modal-open]', e => {
    e.preventDefault()
    const target = e.target.closest('[data-modal-open]')
    const id = target.getAttribute('data-modal-id')
    const modal = document.querySelector(id)

    if (modal) {
      modal.classList.add('active')
      document.body.classList.add('block-scroll')
    }
  })
  
  $(document).on('click', '[data-modal-close]', e => {
    e.preventDefault()
    const target = e.target
    const modal = target.closest('.js-modal')

    if (modal) {
      modal.classList.remove('active')
      document.body.classList.remove('block-scroll')
    }
  })

  $(document).on('click', '.js-load-btn', (e) => {
    e.currentTarget.classList.add('is-loading')
  })
  
  $(document).on('click', '.js-scroll-top', (e) => {
    $('html, body').stop().animate({
      scrollTop: 0,
    }, 500, 'swing');
  })

  init()
}

// ----- init components

const initProjects = () => {
  const msliderItems = document.querySelectorAll('.js-m-slider:not(.active)')

  if ( msliderItems.length ) {
    msliderItems.forEach((el, i) => {
      const index = mslider.length ? mslider.length - 1 + i : 0
      mslider[index] = new MSlider(el)
      mslider[index].init()
      el.classList.add('active')
    })
  }

  const gallery = document.querySelectorAll('.js-gallery:not(.active)')

  if (gallery.length) {
    gallery.forEach(el => {
      Fancybox.bind(el, '[data-fancybox="gallery"]', {
        Images: {
          initialSize: 'fit',
          Panzoom: {
            maxScale: 2
          }
        }
      })
      el.classList.add('active')
    })
  }

  const videoItems = document.querySelectorAll('[data-video]:not(.active)')

  if ( videoItems.length ) {
    videoItems.forEach((el, i) => {
      const index = video.length ? video.length - 1 + i : 0
      video[index] = new VideoOnVisible(el)
      video[index].init()
      el.classList.add('active')
    })
  }

  const ratingItems = document.querySelectorAll('.js-rating:not(.active)')

  if (ratingItems.length) {
    ratingItems.forEach((el, i) => {
      const index = rating.length ? rating.length - 1 + i : 0
      rating[index] = new Rating(el)
      rating[index].init()
      el.classList.add('active')
    })
  }

  ScrollTrigger.refresh()
}

function init () {

  scrollAnimate = new ScrollAnimate()
  
  if (!isFirstLoad) {
    setTimeout(() => {
      scrollAnimate.init()
    }, 150)
  }

  const form = document.querySelectorAll('.wpcf7-form')

  if (form.length) {
    if (!isFirstLoad) {
      console.log('wpcf7reinit')
      form.forEach(el => {
        
        try {
          wpcf7.reset(el);
        } 
        catch (ev) {
          wpcf7.init(el);
        }

      })
    }
  }

  const headerElement = document.querySelector('.js-header')
  if (headerElement) {
    header = new Header(headerElement)
    header.init()
  }

  const textareaEl = document.querySelectorAll('.js-textarea')

  if ( textareaEl.length ) {
    textareaEl.forEach((el, i) => {
      textarea[i] = new Textarea(el)
    })
  }
  
  initProjects()


  ScrollTrigger.refresh()

}

function destroy () {
  scrollAnimate.destroy()
  scrollAnimate = null

  Fancybox.destroy()
  
  if (header) {
    header.destroy()
    header = null
  }

  if (textarea.length) {
    textarea.forEach(el => {
      el.destroy()
    })
    textarea = []
  }
  
  if (mslider.length) {
    mslider.forEach(el => {
      el.destroy()
    })
    mslider = []
  }
  
  if (video.length) {
    video.forEach(el => {
      el.destroy()
    })
    video = []
  }

  if (rating.length) {
    rating = []
  }
}

window.app = {
  initProjects: () => initProjects()
}